// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var PageEnd = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M7.128 3.166a.5.5 0 0 1 .634-.091l.072.054 5 4.5a.5.5 0 0 1 .065.672l-.065.071-5 4.5a.5.5 0 0 1-.73-.677l.061-.066L11.751 8 7.165 3.873a.5.5 0 0 1-.091-.634z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.128 3.166a.5.5 0 0 1 .634-.091l.072.054 5 4.5a.5.5 0 0 1 .065.672l-.065.071-5 4.5a.5.5 0 0 1-.73-.677l.061-.066L7.751 8 3.165 3.873a.5.5 0 0 1-.091-.634z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(PageEnd);
export default ForwardRef;
